/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/plans`, controller.index, makeLayout, render);
};
